import type { EmptyProps as AntdEmptyProps } from 'antd'
import type { PropsWithChildren } from 'react'
import { isEmpty } from '@jhqn/utils'
import { Empty as AntdEmpty } from 'antd'

type MaybeReadonly<T> = T | Readonly<T>

export interface EmptyProps extends PropsWithChildren<Omit<AntdEmptyProps, 'style' | 'className'>> {
  /**
   * 数据
   */
  data?: UnDef<MaybeReadonly<boolean | unknown[] | Numeric | VK<unknown>>>
  /**
   * 是否展示空状态
   * @default true
   */
  showEmpty?: boolean
}

const EmptyContent = ({
  data,
  showEmpty,
  children,
  image = AntdEmpty.PRESENTED_IMAGE_SIMPLE,
  description = '暂无数据',
  ...emptyProps
}: EmptyProps) => {
  if (showEmpty === false) return children

  if (isEmpty(data)) {
    return (
      <div className="absolute inset-0 fccc">
        <AntdEmpty className="[&>*>*]:text-#2c96e9" description={description} image={image} {...emptyProps} />
      </div>
    )
  }

  return children
}

const Empty = ({ className, style, ...emptyProps }: EmptyProps & CommonProps) => {
  return (
    <div className={clsx('h-full w-full', className)} style={style}>
      <EmptyContent {...emptyProps} />
    </div>
  )
}

export default Empty
